import { render } from "./NotificationEventDetailVx.vue?vue&type=template&id=a83988ce&scoped=true"
import script from "./NotificationEventDetailVx.vue?vue&type=script&lang=js"
export * from "./NotificationEventDetailVx.vue?vue&type=script&lang=js"

import "./NotificationEventDetailVx.vue?vue&type=style&index=0&id=a83988ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a83988ce"]])

export default __exports__